// Budget lines ↔ the supplier database. A line is linked to a supplier by its id (set when the supplier is picked
// from the database on the Budget page), or, for lines written before that or filled in from quotes and tenders,
// by the same name. Plain data and the budget maths only, so it is tested on its own.
import { calc, effFx, projectCcy } from './budget.js';

// supplier categories (the same codes as Tenders' brief categories)
export const SUP_CATS = [['av', 'AV & technical production'], ['fb', 'Catering & beverage'], ['dmc', 'DMC & ground handling'], ['hos', 'Hosts & event staff'], ['ven', 'Venue'],
  ['dec', 'Furniture, decor & florals'], ['prn', 'Branding, print & signage'], ['phv', 'Photo & video'], ['ent', 'Entertainment & speakers'], ['gft', 'Gifts & merchandise'], ['oth', 'Other supplier']];
export const supCat = k => (SUP_CATS.find(c => c[0] === k) || SUP_CATS[SUP_CATS.length - 1])[1];

export const supKey = s => String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');

// The supplier a typed name refers to, if it is in the database (same name, ignoring case and spacing)
export function supplierFor(name, directory) {
  const k = supKey(name);
  return k ? directory.find(d => supKey(d.name) === k) || null : null;
}

export const isLinked = (item, supplier) => item.supId ? item.supId === supplier.id : !!item.sup && supKey(item.sup) === supKey(supplier.name);

// Where a supplier appears in the budgets: per project, its lines with planned and actual cost in the project's
// cost currency (as on the Budget page), and the project totals.
export function supplierBudgetUse(supplier, projects) {
  const out = [];
  for (const p of projects || []) {
    const lines = [];
    const fx = effFx(p);
    for (const s of p.sections || []) for (const it of s.items || []) {
      if (!isLinked(it, supplier)) continue;
      const c = calc({ ...it, qty: Number(it.qty) || 0, up: Number(it.up) || 0, vat: Number(it.vat) || 0, mu: Number(it.mu) || 0 }, fx);
      lines.push({ id: it.id, desc: it.desc || '', section: s.name || '', status: it.st || '', planned: c.inGBP, actual: c.actInGBP });
    }
    if (lines.length) out.push({ projectId: p.id, name: p.name || 'Untitled', ccy: projectCcy(p).cost, lines,
      planned: lines.reduce((t, l) => t + (l.planned || 0), 0), actual: lines.some(l => l.actual != null) ? lines.reduce((t, l) => t + (l.actual || 0), 0) : null });
  }
  return out;
}
